var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-share-it-button",class:{
    'dark': _vm.dark,
    'light': !_vm.dark,
    'dense': _vm.dense,
    'outline': _vm.outline
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }